// extracted by extract-css-chunks-webpack-plugin
module.exports = {"errorBox":"_1PLuTu","heading":"_3OuB2O","markdown":"_1xsHU9","phoneNumber":"_2itjCI"};